import { adcApi } from '@configs/axios-instances';
import { AQLQuery } from '@insights_module/adc_ql/types';
import { ISearchAudioResponse } from '@insights_module/types/Episode';

type TrailingEpisodeType = {
  query: AQLQuery;
  sortOrder: string;
  pageNumber?: number;
  pageSize?: number;
};

export function useTagEpisodesData() {
  const getTrailingEpisode = async ({
    query,
    sortOrder,
    pageNumber = 1,
    pageSize = 1,
  }: TrailingEpisodeType) => {
    const res: ISearchAudioResponse = await adcApi.POST.post(
      `/audio/search?page_no=${pageNumber}&page_size=${pageSize}&sort_order=${sortOrder}&sort_field=published_date`,
      { query }
    );

    const {
      data,
      pagination: { total },
    } = res;

    return { data, total };
  };

  return { getTrailingEpisode };
}
